export default __webpack_public_path__ + "assets/bc24a3227085f607b05955a35f6b1611.png";